module.exports = __webpack_public_path__ + "img/borrower-portal.e46d7cd7.png";